module.exports = __webpack_public_path__ + "static/iphone-1-portrait-537fadb2aaa257ee6d368fe0b4de4525.png";